module.exports = __webpack_public_path__ + "static/media/print-sgombero-detail3.b67cf8c2.jpg";